import { render } from "./ForgottenPassword.vue?vue&type=template&id=b3cac212&scoped=true"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"

import "./ForgottenPassword.vue?vue&type=style&index=0&id=b3cac212&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3cac212"]])

export default __exports__